import { Lock, LockOpen } from '@mui/icons-material'
import { Button } from '@mui/material'

interface LockButtonProps {
  disabled?: boolean
  isLocked?: boolean
  onLock: () => void
  onUnlock: () => void
}

export default function LockButton({ disabled, isLocked, onLock, onUnlock }: LockButtonProps) {
  return (
    <Button
      disabled={disabled}
      endIcon={isLocked ? <LockOpen /> : <Lock />}
      onClick={() => {
        if (isLocked) onUnlock()
        else onLock()
      }}
      variant='text'
    >
      {isLocked ? 'UNLOCK' : 'LOCK'}
    </Button>
  )
}
